import { TextBadge } from "@hireart/component-library";
import PropTypes from "prop-types";
/**
 * Shared utility component for rendering week status badges
 * Used across TimecardHeader and ShiftHeader components
 */
export const WeekStatusBadge = ({ status, className = "" }) => {
  switch (status) {
    case "approved":
      return (
        <TextBadge color="success" className={className}>
          Approved
        </TextBadge>
      );
    case "submitted":
      return (
        <TextBadge color="success" className={className}>
          Submitted
        </TextBadge>
      );
    case "deadline_passed":
      return (
        <TextBadge color="blue" className={className}>
          Deadline passed
        </TextBadge>
      );
    case "draft":
      return (
        <TextBadge color="neutral" className={className}>
          Not submitted
        </TextBadge>
      );
    default:
      return null;
  }
};

WeekStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
};
